import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const appointmentDateMachine =
  createTripArrayFieldMachine('appointmentDate');
